<script lang="ts">
  import LinkLocale from '../../components/ui/link-locale.svelte'
  import { parseToSlug } from '../../utils/parseToSlug'

  import { onMount } from 'svelte'

  import { animate } from 'animejs'

  import type { Props } from './work.types'

  const { image, customer, slug, title, description, class: classNative }: Props = $props()

  onMount(() => {
    animate('.gallery-item__wrapper', {
      translateY: [-120, 0],
      opacity: [0, 1],
      duration: 4 * 1000,
    })
  })
</script>

<style>
  .gallery-item__wrapper .gallery-cover figure {
    width: 100%;
    height: 280px;
  }

  .gallery-item__wrapper .gallery-cover img {
    width: 100%;
    height: 100%;

    overflow: hidden;
  }
</style>

<div
  class={`gallery-item__wrapper el-animated | relative w-full cursor-pointer rounded-2xl pb-2 transition hover:bg-gray-50 hover:shadow-sm ${classNative || ''}`}
>
  {@render cover({ ...image, title })}

  <div class="gallery-content | row | gap-3 px-2">
    <div class="gallery-customer | center | size-[32px] flex-shrink-0 rounded-full bg-gray-100">
      <img
        class="size-[24px] rounded-full"
        width="24"
        height="24"
        src={customer.image.url}
        alt={customer.image.alt || 'A Imagem contém a logotipo ou foto do cliente'}
      />
    </div>

    <div class="gallery-information mb-2 space-y-2">
      <h3 class="text-md font-medium sm:text-lg">{title}</h3>
      <p class="text-xs text-gray-600 sm:text-xs">{description}</p>
    </div>

    {@render link({ title, slug })}
  </div>
</div>

<!-- snippet -->
{#snippet cover(image: { url: string; alt: string; title: string })}
  <div class="gallery-cover | mb-3 overflow-hidden rounded-2xl border-8 border-gray-200">
    <figure>
      <img
        class="cover-top"
        width="1400"
        height="900"
        src={image.url}
        alt={image.alt || image.title}
      />
    </figure>
  </div>
{/snippet}

{#snippet link({ title, slug }: { title: string; slug: string })}
  <LinkLocale class="absolute left-0 top-0 size-full" href={`/portfolio/work/${parseToSlug(slug)}`}>
    <span class="sr-only">{title}</span>
  </LinkLocale>
{/snippet}
